import { ref } from 'vue'

/**
 * 简单封装一个toggle，避免状态到处飞。
 * 常用场景：ui展示的开关（展开/收起、隐藏/展示）
 */
export const useToggle = ({
  defaultIs = false,
}) => {
  const is = ref(defaultIs)
  const toggle = (to?: boolean) => {
    if (to !== undefined) {
      is.value = to
    } else {
      is.value = !is.value
    }
  }
  return {
    is,
    toggle,
  }
}